import { render } from "./dialogRename.vue?vue&type=template&id=6635ff0b&scoped=true"
import script from "./dialogRename.vue?vue&type=script&lang=js"
export * from "./dialogRename.vue?vue&type=script&lang=js"

import "./dialogRename.vue?vue&type=style&index=0&id=6635ff0b&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6635ff0b"]])

export default __exports__